import { render, staticRenderFns } from "./baidu-map-component.vue?vue&type=template&id=c4400bbc&scoped=true"
import script from "./baidu-map-component.vue?vue&type=script&lang=js"
export * from "./baidu-map-component.vue?vue&type=script&lang=js"
import style0 from "./baidu-map-component.vue?vue&type=style&index=0&id=c4400bbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4400bbc",
  null
  
)

export default component.exports